import { createElement } from 'react';
import clsx from 'clsx';
import './button.css';

export default function Button(props) {
  const {
    href,
    icon,
    iconPosition,
    onClick,
    children,
    type = 'button',
    id = '',
    className = '',
    color = 'primary',
    disabled = false,
    full = false,
  } = props;

  function isLink() {
    return type === 'link';
  }
  return createElement(
    isLink() ? 'a' : 'button',
    {
      type: isLink ? null : type,
      href: isLink() ? href : null,
      id: id ? id : null,
      disabled: disabled,
      className: clsx('btn', className, {
        ['btn--full']: full,
        ['btn--primary']: color === 'primary',
        ['btn--secondary']: color === 'secondary',
        ['btn--arrow']: icon === 'arrow' && iconPosition,
        ['btn--envelope']: icon === 'envelope' && iconPosition,
        ['btn--before']: iconPosition === 'before' && icon,
        ['btn--after']: iconPosition === 'after' && icon,
      }),
      onClick: onClick,
    },
    <span>{children}</span>,
  );
}
